class ArticleDocument {

    constructor() {

        this._template = null;

        this._defaultReconnectTime = 5000;

        this._editorToken = null;
        this._editing = false;
        this._isPreview = false;
        this._onGeneratedPreview = null;
        this._onSuccessEdit = null;

        this._loadTemplates();

    }

    _loadTemplates() {
        this._template = Handlebars.compile($("#worldDocumentationEditorScreen").html());
    }

    _enableHandlers() {

        $("div.editor.close-button").on("click.cancelArticleEdition", this._onCancelArticleEdition.bind(this));
        $("div.editor.confirm-button").on("click.confirmArticleEdition", this._onConfirmArticleEdition.bind(this));

    }

    _enableSocketEvents() {

        if (!this._isPreview) {
            docSocket.on(SocketEvents.EDITOR_CONTENT_RESPONSE(), this._onEditorContentResponse.bind(this));
            docSocket.on(SocketEvents.EDITOR_STATUS_UPDATED(), this._onEditorStatusUpdated.bind(this));
        }

        docSocket.on(SocketEvents.BIND_EDITOR_CLIENT_RESPONSE(), this._onBindEditorClientResponse.bind(this));

    }

    _disableSoketEvents() {


        if (!this._isPreview) {
            docSocket.off(SocketEvents.EDITOR_CONTENT_RESPONSE());
            docSocket.off(SocketEvents.EDITOR_STATUS_UPDATED());
        }

        docSocket.off(SocketEvents.BIND_EDITOR_CLIENT_RESPONSE());

    }

    getEditorToken() {
        return this._editorToken;
    }

    getIsEditing() {
        return this._editing;
    }

    createArticlePreview(initialHtml, initialCover, initialTitle, onSuccess) {

        this._isPreview = true;
        this._onGeneratedPreview = onSuccess;

        docSocket.emit(SocketEvents.BIND_EDITOR_CLIENT_REQUEST(), JSON.stringify({
            token: this._editorToken,
            edit: {
                initial_html: initialHtml,
                initial_cover: initialCover,
                initial_title: initialTitle
            }
        }));

        this._enableSocketEvents();

    }

    editArticle(initialHtml, initialCover, initialTitle, onSuccess) {

        this._onSuccessEdit = onSuccess;

        docSocket.emit(SocketEvents.BIND_EDITOR_CLIENT_REQUEST(), JSON.stringify({
            token: this._editorToken,
            edit: {
                initial_html: initialHtml,
                initial_cover: initialCover,
                initial_title: initialTitle
            }
        }));

        this._enableSocketEvents();

    }

    _onCancelArticleEdition(event) {

        const $publishSection = $("section.publish-section");
        const documentationNew = documentationScreenController.documentationNew;

        if ($publishSection.length > 0) {
            baseController.closeStack();
        } else {
            baseController.closeStack();
            window.scrollTo(0, documentationNew.lastYScrollPosition);
            documentationNew.onToggleNewButton();
        }

        this.clearData();

    }

    _onConfirmArticleEdition(event) {

        const $this = $(event.currentTarget);

        if ($this.hasClass("enabled")) {
            docSocket.emit(SocketEvents.EDITOR_CONTENT_REQUEST(), JSON.stringify({}));
        }

    }

    _onBindEditorClientResponse(data) {

        function reconectEditor() {
            docSocket.emit(SocketEvents.BIND_EDITOR_CLIENT_REQUEST(), JSON.stringify({
                token: that._editorToken
            }));
        }

        function _generateArticlePreviewUrl() {
            const previewUrl = "/html-editor/preview/" + data.token + "?locale=" + systemLocale;
            that._onGeneratedPreview(previewUrl);
            that.clearData();
        }

        function _generateArticleEdition() {

            that._editing = true;

            if (!that._editorToken) {
                that._editorToken = data.token;
                that._drawScreen();
                that._enableHandlers();
            }

        }

        const that = this;

        if (data.success) {

            if (this._isPreview) {
                _generateArticlePreviewUrl();
            } else {
                _generateArticleEdition();
            }

        } else {
            setTimeout(reconectEditor, this._defaultReconnectTime);
        }

    }

    _onEditorContentResponse(data) {

        if (data.success) {

            const documentationNew = documentationScreenController.documentationNew;
            const documentationPublish = documentationScreenController.documentationPublish;

            if (this._onSuccessEdit) {
                this._onSuccessEdit(data.content);
            } else {
                this.clearData();
                documentationPublish.drawEnterTransitionScreen();
                documentationPublish.initialize(documentationNew.ARTICLE, null, null, data.content);
            }

        }

    }

    _onEditorStatusUpdated(data) {

        if (data.success) {

            switch(data.mode) {

                case "EDITING":
                    this._onEditingMode(data);
                    break;

                case "WAITING_ASSET_IMAGE":
                case "WAITING_ASSET_RANDOM_IMAGE":
                    this._onWaitingAssetImage(data);
                    break;

                case "WAITING_EXTERNAL_CONTENT":
                    this._onWaitingExternalContent(data);
                    break;

            }

        }

    }

    _onEditingMode(data) {

        const $confirmButton = $("div.editor.confirm-button");

        if (data.valid_content) {
            $confirmButton.addClass("enabled");
        } else {
            $confirmButton.removeClass("enabled");
        }

    }

    _onWaitingAssetImage(data) {

        function _onSelectExternalImage(response) {

            let eventData = {}

            if (!response.base64) {
                eventData.image_url = response.url;
            } else {
                eventData.image_base64 = response.url;
            }

            docSocket.emit(SocketEvents.EDITOR_SEND_IMAGE(), JSON.stringify(eventData));

        }

        function _onCancelSelection() {
            docSocket.emit(SocketEvents.EDITOR_CANCEL_OPERATION());
        }

        const $body = $("body");
        const $suggestionsModal = $("#image-suggestions-modal");
        const $chooseImageFromModal = $("#choose-image-from-modal");
        const $catalogueScreen = $("section.catalogue-section");
        const documentationNew = documentationScreenController.documentationNew;

        // Solo abrir la modal de sugerencias o el catalogo si no se ha abierto ya (para evitar problemas de reconexiones con el editor)
        const suggestionModalOpen = $suggestionsModal.length > 0;
        const chooseImageFromModalOpen = $chooseImageFromModal.length > 0;
        const catalogueScreenOpen = $catalogueScreen.length > 0;

        $body.removeClass("no-scroll");

        if (data.mode === "WAITING_ASSET_IMAGE" && !chooseImageFromModalOpen && !catalogueScreenOpen) {
            externalAssetsController.initialize(false, "", documentationNew.ARTICLE, _onSelectExternalImage, _onCancelSelection);
        } else if (data.mode === "WAITING_ASSET_RANDOM_IMAGE" && !suggestionModalOpen) {
            externalAssetsController.initialize(true, "", documentationNew.ARTICLE, _onSelectExternalImage, _onCancelSelection);
        }

    }

    _onWaitingExternalContent(data) {

        function _onSelectExternalContent(response) {

            const $editorSection = $("section.new-document-section");
            let eventData = {};

            if ($editorSection.length > 0) {
                baseController.closeStack();
            }

            if (response.html) {
                eventData.iframe = response.html;
            } else {
                eventData.url = response.url;
            }

            docSocket.emit(SocketEvents.EDITOR_SEND_EXTERNAL_CONTENT(), JSON.stringify(eventData));

        }

        function _onCancelSelection() {
            docSocket.emit(SocketEvents.EDITOR_CANCEL_OPERATION());
        }

        const $body = $("body");
        const $externalContentScreen = $("section.external-content");
        const documentationNew = documentationScreenController.documentationNew;

        // Solo abrir la pantalla de añadir contenido externo si no se ha abierto ya (para evitar problemas de reconexiones con el editor)
        const externalContentScreenOpen = $externalContentScreen.length > 0;

        $body.removeClass("no-scroll");
        documentationNew.externalDocument.initialize(true, _onSelectExternalContent, _onCancelSelection);


    }

    _drawScreen() {

        const documentationNew = documentationScreenController.documentationNew;
        const context = {
            editorToken: this._editorToken,
            systemLocale: systemLocale,
        }
        
        baseController.stackSimpleContent(this._template, context, 'CONTENT');

    }

    initialize() {

        docSocket.emit(SocketEvents.BIND_EDITOR_CLIENT_REQUEST(), JSON.stringify({token: this._editorToken}));
        this._enableSocketEvents();

    }

    clearData() {

        this._editorToken = null;
        this._editing = false;
        this._isPreview = false;
        this._onGeneratedPreview = null;
        this._onSuccessEdit = null;
        this._disableSoketEvents();

    }

}
